
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[seller]/info",
      function () {
        return require("private-next-pages/[seller]/info.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[seller]/info"])
      });
    }
  